import web3Config from "../web3Config";
import { ethers, Wallet } from "ethers";
import fetchMaticPrice from "./fetchMaticPrice";
import getDecryptedAdminKey from "./getDecryptedAdminKey";
const SIGNING_DOMAIN_NAME = "WEB3CLUB";
const SIGNING_DOMAIN_VERSION = "1";
const chain_id = process.env.NEXT_PUBLIC_ACTIVE_CHAIN_ID;
//const chain_id = 137;

const DOMAIN_REGISTRY_CONTRACT_ADDRESS = web3Config.contractAddress;

class SignHelper {
  constructor(contractAddress, chainId, signer) {
    this.contractAddress = DOMAIN_REGISTRY_CONTRACT_ADDRESS;
    this.chainId = chainId;
    this.signer = signer;
  }

  async createSignature(id, amount, domainname) {
    const obj = { id, amount };
    const domain = await this._signingDomain();
    const types = {
      EIP712Domain: [
        { name: "id", type: "uint" },
        { name: "amount", type: "uint" },
      ],
    };

    const signature = await this.signer._signTypedData(domain, types, obj);
    return { ...obj, signature };
  }

  async _signingDomain() {
    if (this._domain != null) {
      // console.log("this.domain not null: " + this._domain);
      return this._domain;
    }
    const chainId = this.chainId;
    //console.log("Chain Id in signning deomanin: " + chainId);
    this._domain = {
      name: SIGNING_DOMAIN_NAME,
      version: SIGNING_DOMAIN_VERSION,
      chainId,
      verifyingContract: this.contractAddress,
    };
    console.log("this.domain: " + this._domain);
    return this._domain;
  }
  static async getSignFromP(contractAddress, chainId, id, amount, domainname) {
    let signer = new Wallet(getDecryptedAdminKey()); //Need to fetch from ADMIN_ACCOUNT_PRIVATE_KEY
    console.log("Address signature: " + signer.address);
    let lm = new SignHelper(contractAddress, chainId, signer);
    let voucher = await lm.createSignature(id, amount, domainname);
    //console.log(voucher.signature);
    return voucher.signature;
  }
}

async function getSignatureForMinting(domainNames, totalPrice, targetWallets, isAdmin) {
  let random_int = Math.floor(Math.random() * 10000000000);
  let maticPrice;
  let totalMaticAmount;
  if (!isAdmin) {
    maticPrice = await fetchMaticPrice();
    console.log("maticPrice: " + maticPrice + "  ///// totalPrice" + totalPrice);
    totalMaticAmount = totalPrice / maticPrice;
    // totalMaticAmount = 0;
    console.log("totalMaticAmount: " + totalMaticAmount);
  } else {
    maticPrice = 0;
    totalMaticAmount = 0;
  }

  let finalMaticAmountInWei = ethers.utils.parseUnits(totalMaticAmount.toString(), "ether").toString();
  let x = SignHelper.getSignFromP(DOMAIN_REGISTRY_CONTRACT_ADDRESS, chain_id, random_int, finalMaticAmountInWei, domainNames);
  let sig = await x.then((result1) => {
    return result1;
  });
  let temp = { sig, random_int, matic_in_wei: finalMaticAmountInWei };
  // setSignature(temp);
  // settotalAmountInMatic(totalMaticAmount);

  let to_Addresses = targetWallets;
  // for (let i = 0; i < domainNames.length; i++) {
  //   to_Addresses[i] = netzyloConnectedAddress;
  // }
  // let config = {
  //   totalPrice: totalMaticAmount,
  //   domainNames,
  //   owners: to_Addresses,
  //   id: random_int,
  //   amount: finalMaticAmountInWei,
  //   signature: sig,
  // };

  return temp;
}
export default getSignatureForMinting;
